import React, { useState } from "react";
import usePredictions from "hooks/predictions/usePredictions";
import usePredictors from "hooks/predictors/usePredictors";
import usePromises from "hooks/promises/usePromises";
import useSurveys from "hooks/surveys/useSurveys";
import MainContent from "components/main-content/MainContent";
import PredictionCard from "components/card/PredictionCard";
import PromiseCard from "components/card/PromiseCard";
import PredictorCard from "components/card/PredictorCard";
import { FiSliders } from "react-icons/fi";

const Main = () => {
  const [predictionsCategory, setPredictionsCategory] = useState("");
  const [promisesCategory, setPromisesCategory] = useState("");
  const [surveysCategory, setSurveysCategory] = useState("");
  const [category, setCategory] = useState("");

  const {
    predictions,
    isLoading,
    getNextPage,
    page,
    setPage,
    hasMoreItems,
    programCategories,
  } = usePredictions(predictionsCategory);

  const {
    predictors,
    isLoading: isLoadingPredictors,
    getNextPage: getNextPagePredictors,
    page: predictorsPage,
    setPage: setPredictorsPage,
    hasMoreItems: hasMorePredictors,
  } = usePredictors(category);

  const {
    promises,
    isLoading: isLoadingPromises,
    getNextPage: getNextPagePromises,
    page: promisesPage,
    setPage: setPromisesPage,
    hasMoreItems: hasMorePromises,
  } = usePromises(promisesCategory);

  const {
    surveys,
    isLoading: isLoadingSurveys,
    getNextPage: getNextPageSurveys,
    page: surveysPage,
    setPage: setSurveysPage,
    hasMoreItems: hasMoreSurveys,
  } = useSurveys(surveysCategory);

  return (
    <div className="w-full min-h-screen bg-slate-50 p-6 sm:p-8 lg:p-10 overflow-y-auto">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Executive Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-6 border-b border-slate-200/80">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="p-2.5 rounded-xl bg-indigo-50 text-indigo-600 border border-indigo-100/80 shadow-xs">
                <FiSliders size={22} />
              </span>
              <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">
                Գլխավոր էջի կարգավորումներ
              </h1>
            </div>
            <p className="text-xs sm:text-sm text-slate-500 mt-1 ml-11">
              Կառավարեք հավելվածի գլխավոր էջում ցուցադրվող ընտրյալ կանխատեսումները, խոստումները և հարցումները
            </p>
          </div>
        </div>

        {/* Content Curation Sections */}
        <div className="space-y-6">
          <MainContent
            items={predictions}
            id="predictions"
            label="Կանխատեսումներ"
            isLoading={isLoading}
            hasMoreItems={hasMoreItems}
            getNextPage={getNextPage}
            page={page}
            setPage={setPage}
            category={predictionsCategory}
            setCategory={setPredictionsCategory}
            categories={programCategories}
            cardComponent={<PredictionCard />}
          />

          <MainContent
            items={promises}
            id="promises"
            label="Խոստումներ"
            isLoading={isLoadingPromises}
            hasMoreItems={hasMorePromises}
            getNextPage={getNextPagePromises}
            page={promisesPage}
            setPage={setPromisesPage}
            category={promisesCategory}
            setCategory={setPromisesCategory}
            categories={programCategories}
            cardComponent={<PromiseCard />}
          />

          <MainContent
            items={predictors}
            id="predictors"
            label="Կանխատեսողներ"
            isLoading={isLoadingPredictors}
            hasMoreItems={hasMorePredictors}
            getNextPage={getNextPagePredictors}
            page={predictorsPage}
            setPage={setPredictorsPage}
            category={category}
            setCategory={setCategory}
            categories={programCategories}
            cardComponent={<PredictorCard />}
          />

          <MainContent
            items={surveys}
            id="surveys"
            label="Ընդհանրական Կանխատեսումներ"
            isLoading={isLoadingSurveys}
            hasMoreItems={hasMoreSurveys}
            getNextPage={getNextPageSurveys}
            page={surveysPage}
            setPage={setSurveysPage}
            category={surveysCategory}
            setCategory={setSurveysCategory}
            categories={programCategories}
            cardComponent={<PredictorCard />}
          />
        </div>
      </div>
    </div>
  );
};

export default Main;
